import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.89 34.64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.66 28.19c1.77 4.02 4.7 6.45 8.28 6.45 3.38 0 5.66-2.8 5.66-5.46 0-3.03-2.13-5.01-4.63-5.01-2.68 0-3.25 2.2-3.25 2.75 0 1.27.97 2.45 2.22 2.45 1.96 0 2.1-1.7 2.1-1.7s.6.41.6 1.5-.82 2.36-2.71 2.36c-1.51 0-3.73-.86-5.26-4.38-1.8-4.12-1.93-5.34-1.93-5.34h23.71l1.35-3.28H0s1.57 4.94 3.66 9.65Zm3.98-14.65s1.85-2.7 5.79-6.75c.99-1.01 3.58-3.55 6.21-3.55 1.73 0 3.08 1.18 3.08 2.78s-1.24 2.05-1.24 2.05c.13-.68-.27-2.53-1.9-2.53s-2.41 1.41-2.41 2.36c0 1.95 1.62 3.35 3.5 3.35 3.63 0 5.32-2.81 5.32-5.53S23.56 0 19.64 0c-3.6 0-6.93 2.78-8.83 4.8C4.07 11.97.51 16.81.51 16.81h30.04l1.35-3.27H7.64Z",
      "data-name": "Layer 1"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "NZ-logo"}) } }